export default "__VITE_ASSET__367c0da3__"